export const projectDetails = [
    {
        key: 1,
        path: "./projects/sensordata1.png",
        video: false,
        title: "Internal Company Dashboard",
        text: `This internal project involved designing an 
        internal dashboard to display <span>real-time 
        sensor data</span> from around the office, including 
        environmental metrics and project resourcing 
        details. The dashboard visualized data through 
        interactive graphs, providing valuable insights 
        into office conditions and project progress. 
        Additionally, it showcased <span>resource allocation</span> 
        and <span>team allotment</span>, enabling better decision-making 
        and efficient project management. The design 
        focused on simplicity and clarity to ensure 
        quick access to key information.`,
        landscape: true,
        hover: true
    },
    {
        key: 2,
        path: "./projects/video.mp4",
        video: true,
        title: "Sustainability Website for CES 2023",
        text: `This project involved designing a 
        sustainability-focused website for <span>CES 2023</span>, 
        showcasing environmental initiatives and 
        innovations. The site emphasized clean, 
        modern design with <span>pixel-perfect</span> execution, 
        reflecting a <span>commitment to detail</span> in every 
        aspect of the user experience. It effectively 
        communicated the brand’s sustainability 
        efforts through engaging visuals and interactive 
        elements, ensuring an immersive and informative experience.`,
        landscape: false,
        hover: false
    },

    {
        key: 3,
        path: "",
        video: false,
        title: "Advanced UI for Fitness Equipment",
        text: `This project involved designing an advanced 
        user interface for fitness equipment, <span>optimized</span> 
        for an <span>85-inch TV screen</span>. The goal was to 
        create a visually engaging and user-friendly 
        interface that provides an immersive workout 
        experience. The UI features <span>interactive elements</span>, 
        <span>real-time performance tracking</span>, and 
        <span>customizable workout routines</span>, all 
        tailored for large-screen 
        display. By prioritizing legibility, intuitive 
        navigation, and dynamic visuals, the interface 
        ensures users can easily access workout data, 
        instructional content, and progress metrics. The 
        design enhances user engagement while maintaining 
        a clean and functional layout on a large display.`,
        landscape: false,
        hover: false
    },
    {
        key: 4,
        path: "",
        video: false,
        title: "AI Chat Platform for Post-Surgery Patients",
        text: `This project involved creating an <span>AI-powered 
        chat</span> platform specifically designed to assist sedated 
        post-surgery patients in communicating with their doctors. 
        The app provides an <span>intuitive</span>, 
        <span>real-time</span> chat interface 
        that allows patients to express their needs, concerns, 
        or ask questions while recovering, even if they are 
        <span>unable to speak or communicate easily</span>. By using AI, 
        the platform helps translate patient inputs into 
        meaningful information for healthcare professionals, 
        ensuring quick and effective communication. 
        The goal was to improve patient care, offering a 
        vital link between patients and doctors during 
        the critical recovery phase.`,
        landscape: false,
        hover: false
    },
    {
        key: 5,
        path: "",
        video: false,
        title: "Sleek UI for Existing Back-End Services",
        text: `This project involved designing a sleek and 
        modern user interface to optimize the interaction 
        with <span>existing back-end services</span>. The goal was to 
        provide users with an intuitive front-end experience 
        that simplifies complex workflows while maintaining 
        robust functionality. By focusing on <span>clean aesthetics</span>, 
        <span>minimalistic design</span>, and <span>efficient 
        navigation</span>, the UI enhances the user’s ability 
        to manage and monitor back-end processes with ease. 
        The design includes <span>dynamic dashboards</span>, 
        <span>real-time data visualization</span>, 
        and seamless <span>integration</span> with the back-end, making 
        it easier for users to interact with powerful systems 
        without compromising on usability or performance.`,
        landscape: false,
        hover: false
    },
    {
        key: 6,
        path: "",
        video: false,
        title: "Touch Based UI for New Input Hardware",
        text: `This project focused on developing a <span>touch-based 
        user interface</span> for a new input hardware system. The 
        goal was to create a seamless, responsive experience 
        that leveraged the hardware’s capabilities while 
        ensuring ease of use. The UI design prioritized <span>touch 
        gestures</span>, <span>intuitive navigation</span>, 
        and <span>real-time feedback</span>, 
        enabling users to interact with the system efficiently 
        and naturally. By integrating user-friendly elements 
        like customizable controls and gesture-based shortcuts, 
        the interface enhances productivity and accessibility, 
        offering a fluid, modern, new experience for users across 
        various industries and various use cases.`,
        landscape: false,
        hover: false
    },
    {
        key: 7,
        path: "",
        video: false,
        title: "Elegant UI for DNA Sequencing Machine",
        text: `This project involved designing an intuitive and 
        visually appealing user interface for a <span>DNA sequencing 
        machine</span>. The goal was to enhance the user experience by 
        simplifying complex data visualizations and making it 
        easier for users to interact with the machine's results. 
        The <span>Angular</span> UI incorporates modern design principles, such as 
        <span>clean layouts</span>, <span>interactive graphs</span>, 
        and <span>color-coded data representations</span>, 
        ensuring that all users can efficiently navigate through the sequencing 
        data. By prioritizing usability and aesthetic appeal, 
        the interface empowers users to make informed decisions 
        based on complex scientific data while maintaining an 
        elegant, streamlined experience.`,
        landscape: false,
        hover: false
    },

    {
        key: 8,
        path: "./projects/Strokes.png",
        video: false,
        title: "Strokes for Chemz",
        text: `This project involved designing a visually 
        stunning <span>website</span> for a calligraphy artist in Dubai, 
        showcasing their watercolor and lettering works. 
        The website's elegant design and intuitive layout 
        helped highlight the artist’s unique creations. 
        As a result, the site led to a <span>67% increase in 
        sales</span> for the business, demonstrating the power 
        of a well-crafted online presence. You can view the site at 
        <a href='https://strokesbychemz.github.io/web/'>Strokes for Chemz</a>`,
        landscape: true,
        hover: false
    },
    {
        key: 9,
        path: "./projects/KeyPlus.png",
        video: false,
        title: "Key Plus Locking Solutions",
        text: `This project involved creating a simple yet 
        effective <span>website</span> for a key-and-locks shop in Kerala. 
        The site lists the various services offered, along 
        with showcasing completed projects and customer 
        testimonials. Built using basic <span>HTML, CSS, and JavaScript</span>, 
        the website provides clear navigation and easy access 
        to essential information, helping the business 
        connect with potential customers.`,
        landscape: true,
        hover: true
    },
    {
        key: 10,
        path: "./projects/Clwapp.png",
        video: false,
        title: "Landmark World Residents",
        text: `This project involved developing a <span>Flutter and 
        Firebase app</span> that consolidates resident details for 
        Landmark World, an apartment complex in Kerala. The 
        app allows authorized users to search for residents 
        based on factors such as apartment numbers or car 
        registration numbers. Modifications to resident data 
        are <span>restricted to admin</span> users, ensuring security and 
        proper management of sensitive information.`,
        landscape: false,
        hover: false
    },
    {
        key: 11,
        path: "./projects/znmbank.png",
        video: false,
        title: "ZNM Bank Ltd.",
        text: `This project involved developing an EMI calculator 
        app in <span>Flutter</span> for a local money-dealing team. The 
        app calculates monthly EMIs based on the principal 
        amount, loan type, and duration, including loans not 
        typically available on the market. The project required 
        close <span>client liaison</span> to ensure the app met specific needs, 
        along with designing a <span>user-friendly UI</span> tailored 
        to the client’s requirements.`,
        landscape: false,
        hover: false
    },
    {
        key: 12,
        path: "./projects/pick-a-path1.png",
        video: false,
        title: "Pick-A-Path Game",
        text: `Pick-A-Path is an interactive, <span>choice-driven game</span> where 
        players navigate through different storylines based on the 
        decisions they make. Each choice influences the game's outcome, 
        offering a unique experience every time. Originally launched on 
        <span>Google Play</span>, this project showcases my ability to design engaging 
        narrative experiences with simple yet captivating gameplay.`,
        landscape: false,
        hover: false
    },
];